import type { StyleSystemProps } from '@withjoy/joykit';

type ToggleWrapperProps = { isFeatured?: boolean; isUnavailable?: boolean };

const toggleWrapper = ({ isFeatured, isUnavailable }: ToggleWrapperProps = {}): StyleSystemProps => ({
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: 6,
  borderRadius: 3,
  gap: 5,
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: isFeatured ? 'warning3' : 'mono3',
  backgroundColor: isFeatured ? 'warning1' : isUnavailable ? 'mono1' : 'white',
  marginBottom: 5,
});

const appPlatFormToggleWrapper = (props: ToggleWrapperProps = {}): StyleSystemProps => ({
  ...toggleWrapper(props),
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'center',
});

export const styles = {
  toggleWrapper,
  appPlatFormToggleWrapper,
};
